import {Button} from '@mui/material';
import {FC} from 'react';
import {useRecoilValue, useSetRecoilState} from 'recoil';
import {managerListModalAtom} from '../store/manager-list-modal.store';
import {authState} from '../../../../store/auth/atoms';
import {checkAuthorities} from '../../../../shared/helpers/checkAuthorities';
import {TypeAccountRoles} from '../../../../shared/types/user-account.types';

const ALLOWED_CHANGE_MANAGER_ROLES: TypeAccountRoles[] = [
  TypeAccountRoles.PROJECT_MANAGER,
  TypeAccountRoles.DIRECTOR,
  TypeAccountRoles.FUNCTIONAL_ADMIN,
  TypeAccountRoles.ADMIN,
  TypeAccountRoles.OWNER,
];

export const ShowManagerList: FC = () => {
  const setListModalVisible = useSetRecoilState(managerListModalAtom);
  const {user} = useRecoilValue(authState);
  const canChangeManager = checkAuthorities(ALLOWED_CHANGE_MANAGER_ROLES, [...(user?.roles || [])]);

  const handleClick = () => {
    setListModalVisible(true);
  };

  return (
    <Button variant="text" onClick={handleClick} disabled={!canChangeManager}>
      Поменять
    </Button>
  );
};
